/**
 * Store complete book models (photos, backgrounds, stickers, etc...)
 */
fx.ns("repositories", class PrintRepository extends repositories.BaseRepository {

    constructor(saver, history) 
    {
        super({
            creation: new models.ProductPrint({ id: "" }), // id empty so it's not created in db 
            zoom : new models.Zoom(),
        }, saver, history);

        // TODO : to remove
        fx.set("printmodel", this);
    }

    get print()
    {
        return this.creation;
    }

    report(raw)
    {
        return { failed : this.creation.numPrints < this.creation.minPages};
    }

    create()
    {
        this.post( "/app/create", {  product_id : this.productid, style : this.choosedShape }, this.onCreateData);

        this.event("create-creation");
    }


    initData(data)
    {
        super.initData(data);

        this.creation.init(data.creation, {"CreationElement" : "ProductPrintPage"});

        this.creation.creationOption = data.creationOption;
    }

    getOptions()
    {
        this.post( "/app/options", {  creationid : this.creation.id, numPrints : this.creation.numPrints}, this._onOptionsData);
    }

    // returns layout by adding opposite rotation to picture
    getLayout(id, orientation)
    {
         let layout = this.layouts.find({id : id});

         if (layout)
         {
            let photoComponent = layout.getPhotos()[0];

            if (orientation !== undefined && photoComponent)
            {
                photoComponent.width_inner = 0;
            }
        }
        return layout;
    }

    addPrint(photo)
    {
        let print = this.print.addPrint();

        let shape = "square";
        if (this.print.pageWidth != this.print.pageHeight)
        {
            if (photo.width > photo.height)
                shape = "landscape";
            else 
            //if (photo.width < photo.height)
                shape = "portrait";
        }

        let layout;
        if (this.print.details) // we store in details collection_id
            layout = this.layouts.getItemAt( this.print.elements.length % this.layouts.length);
        else
            layout = this.layouts.getDefaultLayout(shape);	

        if (layout)
        {
            layout = this.getLayout(layout.id, photo.orientation);

            print.applyLayout( layout, this.print.pageWidth, this.print.pageHeight);
        }

        print.photosComponents.getItemAt(0).content = photo.id;

        
    }

    updatePrintShape()
    {
        if (this.print.pageWidth != this.print.pageHeight)
        {
            let printPage = this.print.elements.getItemAt(0);

            if (printPage)
            {

                let photoComponent = printPage.photosComponents.getItemAt(0);
                if (!photoComponent)
                    return;

                if (photoComponent.width > photoComponent.height)
                    this.print.update({shape_option : "landscape"});
                else
                    this.print.update({shape_option : "portrait"});
            }
        }
        else
            this.print.update({shape_option : "square"});
    }


     onUpdated(action)
     {
         super.onUpdated(action);

         if ( (action.type == "removeItem" || action.type == "addItem" || action.type == "addItemAt") && action.data instanceof models.ProductPrintPage)
            this.delay(this.updatePrintShape,150);
     }

    /**
     * A photo placed in a print holds a temporary id until its upload ends, then the real one.
     * The upload queue lives in the page : closed before the end, it leaves components whose
     * temporary id no photo will ever answer to, and the print goes out blank (creation 4386564,
     * 99 prints of 116). A photo still uploading in this page answers to it, and is not lost.
     * Answers the prints to remove and the number of photos lost.
     */
    lostPhotoPrints()
    {
        let prints = [], photos = {};

        for (let i = 0; i < this.print.elements.length; i++)
        {
            let print = this.print.elements.getItemAt(i);

            for (let j = 0; j < print.photosComponents.length; j++)
            {
                let content = print.photosComponents.getItemAt(j).content;

                if (Utils.isID(content) && !this.photos.find({ id : content }) && !this.photos.find({ temporaryId : content }))
                {
                    photos[content] = true;

                    if (prints.indexOf(print) == -1)
                        prints.push(print);
                }
            }
        }

        return { prints : prints, photos : Object.keys(photos).length };
    }

    // removes the prints of lostPhotoPrints() and answers how many photos were lost
    removeLostPhotoPrints()
    {
        let lost = this.lostPhotoPrints();

        for (let i = 0; i < lost.prints.length; i++)
            lost.prints[i].delete();

        if (lost.prints.length > 0)
            this.save();

        return lost.photos;
    }

     addPhotosForCreation()
     {
        if (!this.creation.started && this.creation.photosForCreations.length > 0 && this.creation.numPrints == 0)
        {
            for(let i = 0; i < this.creation.photosForCreations.length; i++)
            {
                let photoId = this.creation.photosForCreations.getItemAt(i);
                let photo = this.photos.find({id : photoId});
                if (photo)
                    this.addPrint( photo );
            }
        }
            
     }

});
